<section
  class="flex h-full w-full flex-col overflow-hidden bg-white"
  role="dialog"
  [attr.aria-label]="(isEditMode ? 'edit_funnel' : 'create_funnel') | translate"
>
  <header class="flex items-center justify-between gap-3 border-b border-gray-100 px-5 py-4">
    <h2 class="m-0 text-lg font-bold text-gray-900">
      {{ (isEditMode ? 'edit_funnel' : 'create_funnel') | translate }}
    </h2>
    <button
      type="button"
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100"
      [attr.aria-label]="'close' | translate"
      [disabled]="isSaving"
      (click)="onClose()"
    >
      <app-icon>close</app-icon>
    </button>
  </header>

  <div class="crm-scroll min-h-0 flex-1 overflow-y-auto px-5 py-4">
    <label class="mb-1.5 block text-sm font-medium text-gray-700">{{ 'name_funnel' | translate }}</label>
    <input
      type="text"
      [formControl]="nameControl"
      [placeholder]="'enter_funnel_name' | translate"
      class="h-10 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm text-gray-800 outline-none focus:border-blue-400"
      [class.border-red-400]="nameControl.invalid && nameControl.touched"
      (keydown.enter)="onSave()"
    />
    @if (nameControl.invalid && nameControl.touched) {
      <p class="mt-1 text-xs text-red-500">{{ 'field_cannot_be_empty' | translate }}</p>
    }
  </div>

  <footer class="flex justify-end gap-3 border-t border-gray-100 px-5 py-4">
    <app-button [btnType]="'cancel'" [disabled]="isSaving" (onChangeClick)="onClose()">
      {{ 'cancel' | translate }}
    </app-button>
    <app-button [disabled]="isSaving" (onChangeClick)="onSave()">
      {{ (isSaving ? 'saving' : 'save') | translate }}
    </app-button>
  </footer>
</section>
